import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {CodebookModel} from '@/libs/Api';
import {CodebooksDataService} from '@/libs/codebooks/codebooks-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const codebooksStore = registerCrudStore<CodebookModel, CodebookModel>(StoreName.Codebook, new CodebooksDataService());
